import styled from "styled-components";

const LoginPageStyle = styled.div`
  height: 100vh;
  display: grid;
  grid-template-columns: 4fr 6fr;
  background-color: #fff;

  .loginContainer {
    display: grid;
    grid-template-rows: 1fr auto 1fr;
    grid-gap: 8px;
    height: 100%;
    box-sizing: border-box;
    padding: 24px 32px;
    background-color: #242939;

    .loginContainer__error {
      width: 438px;
      margin-left: auto;
      margin-right: auto;
      align-self: end;
    }

    .loginContainer__main {
      width: 438px;
      display: grid;
      margin: auto;

      .loginContainer__main__window {
        background-color: ${(props) => props.theme.palette.background.paper};
        padding: 24px 32px;
        display: grid;
        grid-template-rows: auto auto;
        border-radius: 3px;
        box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);

        .loginContainer__main__window__header {
          min-height: 76px;
          max-width: 372px;

          .loginContainer__main__window__subheader {
            margin: 8px 0 24px 0;
          }
        }

        form > div {
          height: 72px;
        }

        .signUpPassword {
          height: 96px !important;
          margin-top: 8px;
        }

        .loginPassword {
          margin-top: 8px;
        }

        > *,
        form > * {
          width: 100%;
        }

        .loginContainer__main__window__buttons {
          height: 48px;
          align-content: end;
          align-self: end;
          display: grid;
          justify-content: space-between;
          grid-template-columns: auto auto;

          .loginContainer__main__window__buttons__resetlink {
            align-self: center;
            a {
              color: ${(props) => props.theme.palette.secondary.main};
            }
          }
        }

        .loginContainer__main__window_signupbutton {
          height: 48px;
          align-content: end;
          align-self: end;
          display: grid;
          justify-content: end;

          button {
            min-width: 96px;
          }
        }
      }

      .loginContainer__main__privacy {
        margin-top: 12px;
        text-align: center;
        color: #fff;
      }

      .loginContainer__main__additionaloption {
        margin-top: 24px;
        text-align: center;
        color: #fff;
      }
    }

    .loginContainer__info {
      padding: 64px;
      display: grid;
      text-align: center;

      .loginContainer__info__primarytext {
        margin-top: 24px;
      }

      .loginContainer__info__secondarytext {
        margin-top: 24px;
      }

      .loginContainer__info__button {
        justify-self: center;
        margin-top: 36px;
      }

      .loginContainer__info__additionaloption {
        margin-top: 48px;
      }
    }

    .loginContainer__footer {
      align-self: end;

      .loginContainer__footer__link {
        margin-top: 12px;
      }
    }
  }

  @media (max-width: 800px) {
    grid-template-columns: 100%;
  }
`;

export default LoginPageStyle;
